/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Dispatch } from '../redux';
import { NotaryAPI } from '../api/notary/types';
import { CommonAPI } from '../api/common/responses';

export function setCallDetails(callDetails: NotaryAPI.CallDetailsResponse | CommonAPI.CallDetailsResponse) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_CALL_DETAIL',
      payload: callDetails,
    });
  };
}

export function resetCallDetail() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_CALL_DETAIL',
      payload: null,
    });
  };
}
